<section class="page">
  <header class="page-header">
    <div>
      <h1>Dashboard</h1>
      <p>Overview of Rentwize platform activity</p>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }

  <div class="stat-grid">
    <a class="stat-card" routerLink="/users">
      <div class="stat-label">Total users</div>
      <div class="stat-value">{{ loading() ? '—' : usersTotal() }}</div>
    </a>
    <a class="stat-card" routerLink="/rent-payments">
      <div class="stat-label">Rent payments</div>
      <div class="stat-value">{{ loading() ? '—' : rentTotal() }}</div>
    </a>
    <a class="stat-card" routerLink="/transactions">
      <div class="stat-label">Transactions</div>
      <div class="stat-value">{{ loading() ? '—' : txTotal() }}</div>
    </a>
    <a class="stat-card" routerLink="/card-programs">
      <div class="stat-label">Card programs</div>
      <div class="stat-value">{{ loading() ? '—' : cardProgramsTotal() }}</div>
    </a>
    <a class="stat-card" routerLink="/kobble">
      <div class="stat-label">Kobble</div>
      <div class="stat-value">
        @if (loading()) {
          —
        } @else if (kobbleConfigured() === null) {
          —
        } @else {
          {{ kobbleConfigured() ? 'OK' : 'Off' }}
        }
      </div>
    </a>
  </div>
</section>
